module.exports = __webpack_public_path__ + "img/myspace-circled.a49a6e16.png";